<svg class:up width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M1.5575 0.148438L5 3.74074L8.4425 0.148438L9.5 1.25436L5 5.96043L0.5 1.25436L1.5575 0.148438Z" fill="#FE6E02" />
</svg>

<script>
  export let up = false;
</script>

<style lang="postcss">
  svg {
    @apply transform duration-100;
  }

  svg.up {
    @apply rotate-180;
  }
</style>